import AbstractWidgetNotification from './YPAbstractWidgetNotificationObject';

export default class RosterNotification extends AbstractWidgetNotification {
  isRosterNotification() {
    return true;
  }

  getPath() {
    return 'rosterNotifications';
  }

  getNotifications(rosterNotifications, updateNotifications, timesheetNotifications) {
    return rosterNotifications;
  }
}
